/* eslint-disable no-unused-vars */
import { Box } from "@mui/material";
import React, { SyntheticEvent, useEffect, useState, useCallback, useMemo } from "react";
import TabCustom from "./components/Tab/TabCustom";
import TabsCustom from "./components/Tabs/TabsCustom";
import OrdersContent from "./OrdersContent/OrdersContent";
import PrescriptionsContent from "./PrescriptionsContent/PrescriptionsContent";
import StoreBanner from "./components/StoreBanner";
import ComingSoon from "./components/ComingSoon/ComingSoon";
import { useAllServiceStatusStore } from "../../../hooks";
import { Loading } from "../../../components";
import { userActivityLogger } from "../../../utils/mixpanel";
import { MIXPANEL_EVENTS } from "../../../config/mixPanelEvents";
import { useOnlinePharmacyConfig } from "../../../services/online-pharmacy-config/online-pharmacy-config.service";
import TryAgain from "./PrescriptionsContent/components/TryAgain/TryAgain";

enum StoreTab {
  ORDERS = "orders",
  PRESCRIPTIONS = "prescriptions",
}

const StoreContainer = () => {
  const [tabValue, setTabValue] = useState<StoreTab>(StoreTab.ORDERS);
  const { isOnlinePharmacyServiceAvailable, isServiceStatusStoreUpdated } = useAllServiceStatusStore();
  const { executeGetConfig, data: configData, loading: configLoading, error: configError } = useOnlinePharmacyConfig();

  useEffect(() => {
    executeGetConfig();
  }, [executeGetConfig]);

  const handleTabChange = useCallback((_event: SyntheticEvent, value: string) => {
    setTabValue(value as StoreTab);
  }, []);

  useEffect(() => {
    userActivityLogger(MIXPANEL_EVENTS.PHARMACY_TAB_VIEWED, {
      tab: tabValue,
      source: "shop",
    });
  }, [tabValue]);

  const isServiceAvailable = useMemo(
    () => isOnlinePharmacyServiceAvailable || configData?.isServiceEnabled,
    [isOnlinePharmacyServiceAvailable, configData?.isServiceEnabled],
  );

  if (!isServiceStatusStoreUpdated || configLoading) {
    return (
      <Box className="flex justify-center items-center h-full mb-20">
        <Loading />
      </Box>
    );
  }

  if (configError || !configData) {
    return <TryAgain onTryAgain={executeGetConfig} />;
  }

  if (!isServiceAvailable) {
    return (
      <Box className="flex justify-center items-center h-full mb-20">
        <ComingSoon
          title={configData.comingSoon.title}
          message={configData.comingSoon.message}
          imageUrl={configData.comingSoon.imageUrlWeb}
          learnMoreUrl={configData.comingSoon.learnMoreUrl}
        />
      </Box>
    );
  }

  return (
    <Box className="w-full mb-6">
      <StoreBanner
        title={configData.banner.title}
        description={configData.banner.description}
        buttonText={configData.banner.buttonText}
        imageUrl={configData.banner.imageUrlWeb}
        actionUrl={configData.banner.actionUrl}
      />
      <Box className="flex flex-col ">
        <TabsCustom ariaLabel="store-tabs" value={tabValue} onChange={handleTabChange}>
          <TabCustom label="Orders" value={StoreTab.ORDERS} />
          <TabCustom label="Prescriptions" value={StoreTab.PRESCRIPTIONS} />
        </TabsCustom>
        <Box className="mt-6">
          {tabValue === StoreTab.ORDERS && <OrdersContent shopUrl={configData.shopUrl} />}
          {tabValue === StoreTab.PRESCRIPTIONS && <PrescriptionsContent shopUrl={configData.shopUrl} />}
        </Box>
      </Box>
    </Box>
  );
};

export default StoreContainer;
